import React from "react";
import { Button } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import BarChartIcon from "@material-ui/icons/BarChart";
import clsx from "clsx";
import { useTranslation } from "react-i18next";

interface Props {
  onClick: () => void;
  className?: string;
  disabled?: boolean;
}

const useStyles = makeStyles(() => ({
  root: {
    display: "flex",
    width: "100%",
    height: "100%",
    alignItems: "center",
    justifyContent: "center",
  },
}));

/**
 * Placeholder shown where a consumption diagram will go, until the user asks for it.
 *
 * Fills the space the diagram would occupy so the surrounding layout does not shift when
 * the chart appears. See `useDeferredConsumption` for why the data is not loaded up front.
 */
function ShowDiagramButton({ onClick, className, disabled }: Props) {
  const { t } = useTranslation("common");
  const classes = useStyles();

  return (
    <div className={clsx(classes.root, className)}>
      <Button
        variant="outlined"
        color="primary"
        onClick={onClick}
        disabled={disabled}
        startIcon={<BarChartIcon />}
      >
        {t("showConsumptionDiagram")}
      </Button>
    </div>
  );
}

export default ShowDiagramButton;
